module.exports = __webpack_public_path__ + "img/secret_five.bd719ba1.png";